export const dataProperties = {
  emails: 'emails',
  phoneNumber: 'phoneNumber',
  locationInfo: 'locationInfo',
  businessHours: 'businessHours',
  bingMap: 'bingMap',
};
